import { Children, useRef, useEffect, useLayoutEffect } from 'react';
import styled from 'styled-components';
import { WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PopoverContainer = styled.div.withConfig({
  displayName: "SpotlightAddMenu__PopoverContainer"
})(["display:", ";position:absolute;bottom:100%;left:0;margin-bottom:6px;background-color:", ";border-radius:8px;box-shadow:0 2px 8px rgba(20,20,20,0.25);min-width:180px;z-index:9999;overflow:hidden;outline:none;&:focus,&:focus-visible{outline:none;}"], ({
  $isOpen
}) => $isOpen ? 'block' : 'none', WHITE);
const SpotlightAddMenu = ({
  trigger,
  isOpen,
  onClose,
  children
}) => {
  const popoverRef = useRef(null);
  useLayoutEffect(() => {
    var _popoverRef$current;
    if (isOpen) (_popoverRef$current = popoverRef.current) === null || _popoverRef$current === void 0 || _popoverRef$current.focus({
      preventScroll: true
    });
  }, [isOpen]);
  useEffect(() => {
    if (!isOpen) return undefined;
    const handleMouseDown = e => {
      var _popoverRef$current2;
      if ((_popoverRef$current2 = popoverRef.current) !== null && _popoverRef$current2 !== void 0 && _popoverRef$current2.contains(e.target)) return;
      onClose();
    };
    const handleKeyDown = e => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown);
    window.addEventListener('blur', onClose);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('blur', onClose);
    };
  }, [isOpen, onClose]);
  if (Children.toArray(children).length === 0) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [trigger, /*#__PURE__*/_jsx(PopoverContainer, {
      ref: popoverRef,
      role: "menu",
      "aria-label": "Add options",
      $isOpen: isOpen,
      tabIndex: isOpen ? 0 : -1,
      children: children
    })]
  });
};
SpotlightAddMenu.displayName = 'SpotlightAddMenu';
export default SpotlightAddMenu;